import JupyterContainer from './JupyterContainer';

export default JupyterContainer;
